import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useField, connect } from 'formik';
import styled from 'styled-components';

import FieldContextFeeder from '../components/FieldContextFeeder';

import { Select, Gap } from '~ui-kit';

import { useMunicipalityOptions, useOfficeOptions } from '~hooks';

const OfficeField = props => {
  const userOrganization = useSelector(
    state => state.user.data.ordererOrganization
  );
  const [municipality, setMunicipality] = useState();
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const { setFieldValue } = props.formik;
  const { labelWidth } = props;

  const name = props.id || props.name;

  const localProps = {
    ...field,
    ...props,
    error,
    // https://github.com/formium/formik/issues/789
    onChange: option => {
      setFieldValue(name, option);
      if (props.onChange) props.onChange(option);
    },
  };

  const municipalityOptions = useMunicipalityOptions();
  const officeOptions = useOfficeOptions(municipality);

  // If there's no value, fill in user organization's office
  useEffect(() => {
    if (field.value || municipality || !userOrganization) return;

    const userOffice = officeOptions?.find(
      office => office.value === userOrganization.officeId
    );
    if (userOffice) {
      setFieldValue(name, userOffice);
      setMunicipality({
        value: userOffice.municipalityCode,
        label: userOffice.municipalityName,
      });
      if (props.onChange) props.onChange(userOffice);
    }
  }, [field.value, municipality, userOrganization]);

  // // If office is chosen before municipality, fill in municipality for the user
  // useEffect(() => {
  //   if (field.value && !municipality) {
  //     const office = officeOptions?.find(office => office.id === field.value);
  //     if (office) {
  //       setMunicipality({
  //         value: office.municipalityCode,
  //         label: office.municipalityName,
  //       });
  //     }
  //   }
  // }, [field.value]);

  return (
    <Container>
      <Select
        label="Kunta"
        placeholder="Valitse..."
        options={municipalityOptions}
        onChange={value => {
          setMunicipality(value);
          setFieldValue(name, null);
        }}
        value={municipality}
        flat={props.flat}
        labelWidth={labelWidth}
      />
      <Gap height="24px" />
      <Select
        {...localProps}
        fallbackLabel="Toimipiste"
        fallbackPlaceholder="Valitse..."
        options={officeOptions}
        flat={props.flat}
        labelWidth={labelWidth}
        error={error}
      />
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);
`;

export default FieldContextFeeder(connect(OfficeField));
